import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppThemeProvider } from '@/theme/AppThemeProvider';
import { ToastProvider } from '@/ui';
import { router } from '@/app/router';
import { authService } from '@/core/services/authService';
import { prefsService } from '@/core/services/prefsService';
import { initAnalytics } from '@/core/lib/analytics';

// ── App boot sequence ─────────────────────────────────────────────────────────
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

async function boot(): Promise<void> {
  // 0. First-party, cookieless Umami analytics — injects nothing at all unless
  //    VITE_UMAMI_WEBSITE_ID was baked into this build (see core/lib/analytics.ts).
  initAnalytics();
  // 1. Hydrate the session from the server cookie (real auth). 200 → signed in; else guest.
  await authService.loadSession();
  // 2. Load the active account's (or guest) saved prefs so the app opens themed correctly.
  await prefsService.getPreferences();

  createRoot(rootEl!).render(
    <StrictMode>
      <AppThemeProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AppThemeProvider>
    </StrictMode>,
  );
}

void boot();
